import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		card: {
			height: '100%'
		},
		cardContent: {
			height: '100%',
			display: 'flex',
			flexDirection: 'column'
		},
		headerIcon: {
			marginRight: theme.spacing(1)
		},
		headerActions: {
			display: 'flex',
			alignItems: 'center',
			gap: theme.spacing(1)
		},
		errorAlert: {
			marginBottom: theme.spacing(2)
		},
		errorList: {
			margin: 0,
			paddingLeft: theme.spacing(2)
		},
		inputArea: {
			border: `2px dashed ${theme.palette.grey[300]}`,
			borderRadius: theme.shape.borderRadius,
			padding: theme.spacing(1),
			backgroundColor: theme.palette.grey[50]
		},
		textField: {
			height: '100%',
			alignItems: 'flex-start',
			fontFamily: 'monospace',
			fontSize: '0.875rem'
		},
		textFieldInput: {
			height: '100%',
			resize: 'none'
		},
		hiddenFileInput: {
			display: 'none'
		}
	} satisfies Record<string, CSSObject>;
};